import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"

export default function CQ9DoubleGrandGift() {
  const navigate = useNavigate()
  const data = promotionsData.find((promo) => promo.title === "CQ9 Christmas")
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charset="utf-8" />
        <title>CQ9 Christmas</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/"> Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>CQ9 Christmas</h1>
                <h2>Total prize soars to ₱250,000,000</h2>
                <div className="promotion-tnc-period">
                  <strong> Event Period: </strong>
                  <span> December 18 (12PM) - January 15 (12PM)</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <strong> Mechanics: </strong>
                <ol>
                  <li>
                    During the event period, you can participate in the "Total
                    Winning Multipliers Leaderboard" by playing the "Slot" games
                    from CQ9 Legend Electronics!
                  </li>
                  <li>
                    During the event period, players will be ranked based on the
                    sum of their single-game winning multipliers.
                  </li>
                  <li>
                    Rewards will be given based on the betting amount multiplied
                    by the corresponding multiplier on the ranking.
                  </li>
                  <li>
                    For betting amounts exceeding ₱230, they will be counted as
                    ₱230.
                  </li>
                  <li>Total of 4,000 prizes daily.</li>
                  <li>
                    Daily settlement of the game bonus, with prizes calculated
                    based on the bet amount of the highest single-game winning
                    multiplier.
                  </li>
                </ol>
                <div className="table-wrapper">
                  <table
                    className="promotion-tnc-table"
                    style={{ minWidth: "0" }}
                  >
                    <thead>
                      <th colSpan={2}>
                        🏆 Total Winning Multipliers Leaderboard
                      </th>
                    </thead>
                    <tbody>
                      <tr>
                        <td> 1 </td>
                        <td> x5,000</td>
                      </tr>
                      <tr>
                        <td> 2-3 </td>
                        <td> x2,000</td>
                      </tr>
                      <tr>
                        <td> 4-5 </td>
                        <td> x1,000 </td>
                      </tr>
                      <tr>
                        <td> 6-10 </td>
                        <td> x300 </td>
                      </tr>
                      <tr>
                        <td> 11-50 </td>
                        <td> x80 </td>
                      </tr>
                      <tr>
                        <td> 51-100 </td>
                        <td> x30 </td>
                      </tr>
                      <tr>
                        <td> 101-500 </td>
                        <td> x10 </td>
                      </tr>
                      <tr>
                        <td> 501-4000 </td>
                        <td> x5 </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="promotion-tnc-cta">
                  <a
                    className="promotion-cta-btn"
                    href="https://betking.jiamengweiquan.com/xmasph"
                    target="_blank"
                  >
                    View Full T&C
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
